import React from "react";

const Loader = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: "200px",
      }}
    >
      <img
        src="/gif/LoaderDot.gif"
        alt="Loading"
        style={{
          width: "100px",
          height: "110px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // PERFECT CENTER
        }}
      />
    </div>
  );
};

export default Loader;
